import { render, staticRenderFns } from "./nav_cart.vue?vue&type=template&id=812e58d6&"
import script from "./nav_cart.vue?vue&type=script&lang=js&"
export * from "./nav_cart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports